import { createTextVNode as t } from "vue";
function f(e, ...n) {
  return typeof e == "function" ? e(...n) : typeof e == "string" ? t(e) : typeof e == "number" ? t(String(e)) : null;
}
export {
  f as render
};
